import React, { Component } from 'react';
import Socialicons from './Socialicons';
import Copyright from './Copyright';
import EmailSignup from './EmailSignup';

class Footer extends Component {
  render() {
    // don't show footer on info page
    const showFooter = location.pathname.split("/")[1] === "info" ? false : true;
    return (
      showFooter &&
      <div id="footer">
        <div className="address">
          <p className="email-white"><a href="mailto:info@anywaysnyc.com"></a></p>
          <div className="extended-line"><div className="line"></div><p><a href="mailto:info@anywaysnyc.com">info@anywaysnyc.com</a></p></div>
          <div className="extended-line"><div className="line"></div><p>200 Morgan Ave</p></div>
          <p>Studio#3, Brooklyn, NY</p>
        </div>
        <div className="signup">
          <EmailSignup includeName={false} />
        </div>
        <div className="social">
          <Socialicons />
          <p>@anywaysnyc</p>
          <p>#anywaysheresthething</p>
        </div>
        <Copyright />
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/All/Footer.js